import { Container, Row, Col } from "react-bootstrap";
import ruptu from "../assets/img/ruptu.png"
import github from "../assets/img/github.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const Footer = () => {
  return (
    <footer className="footer h-500">
      <Container>
        <Row className="align-items-center">
         
          <Col size={12} sm={6}>
            <img src={ruptu} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end mt-3 p-3 ">
            <div className="social-icon">
              <a href="https://www.linkedin.com/in/ruptu-das-5a3366200/" target="blank"><img src={navIcon1} alt="Icon" /></a>
              <a href="https://github.com/RuptuDas011" target="blank"><img src={github} alt="Icon" /></a>
              <a href="https://www.instagram.com/ruptudas011/" target="blank"><img src={navIcon3} alt="Icon" /></a>
            </div>
            <p>Thank You For Visiting.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
